import React from 'react'

export const Helmet = (props) => {

    document.title = "João Pedro | Robótica, IoT e Desenvolvimento"
  return (
    <div>{props.children}</div>
  )
}
